// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"393": "18ecdf016fd3978b","50": "18901085ba2aa384","85": "43a94a35f7b14f1d","944": "4287f164c8532a75",}[chunkId] + ".js"
}